export const GATSBY_MAIN_URL = process.env.GATSBY_MAIN_URL || 'https://margex.com'
export const GATSBY_MAIN_WS_URL = process.env.GATSBY_MAIN_WS_URL || 'wss://dev.margex.ch'
export const GATSBY_MAIN_ACHIVMENTS_URL =
  process.env.GATSBY_MAIN_ACHIVMENTS_URL || 'https://assets.margex.com/assets/achievements/'
